import React from 'react';
import * as RadixAlertDialog from '@radix-ui/react-alert-dialog';

export type AlertDialogProps = {
  open?: boolean;
  defaultOpen?: boolean;
  onOpenChange?: (open: boolean) => void;
  trigger?: React.ReactNode;
  title: React.ReactNode;
  description?: React.ReactNode;
  confirmLabel?: string;
  cancelLabel?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
  destructive?: boolean;
};

export const AlertDialog: React.FC<AlertDialogProps> = ({
  open,
  defaultOpen,
  onOpenChange,
  trigger,
  title,
  description,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  onConfirm,
  onCancel,
  destructive,
}) => (
  <RadixAlertDialog.Root open={open} defaultOpen={defaultOpen} onOpenChange={onOpenChange}>
    {trigger && <RadixAlertDialog.Trigger asChild>{trigger}</RadixAlertDialog.Trigger>}
    <RadixAlertDialog.Portal>
      <RadixAlertDialog.Overlay
        style={{
          position: 'fixed',
          inset: 0,
          background: 'rgba(13, 16, 39, 0.5)',
          zIndex: 100,
        }}
      />
      <RadixAlertDialog.Content
        className="card card-pad"
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
          width: '90vw',
          maxWidth: 440,
          padding: 24,
          zIndex: 101,
          boxShadow: 'var(--shd-3)',
        }}
      >
        <RadixAlertDialog.Title style={{ fontSize: 18, fontWeight: 600, color: 'var(--ink)' }}>
          {title}
        </RadixAlertDialog.Title>
        {description && (
          <RadixAlertDialog.Description className="muted" style={{ marginTop: 8, fontSize: 14 }}>
            {description}
          </RadixAlertDialog.Description>
        )}
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end', marginTop: 20 }}>
          <RadixAlertDialog.Cancel asChild>
            <button type="button" className="btn btn-secondary btn-sm" onClick={onCancel}>
              {cancelLabel}
            </button>
          </RadixAlertDialog.Cancel>
          <RadixAlertDialog.Action asChild>
            <button
              type="button"
              className={`btn btn-sm ${destructive ? 'btn-danger' : 'btn-primary'}`}
              onClick={onConfirm}
            >
              {confirmLabel}
            </button>
          </RadixAlertDialog.Action>
        </div>
      </RadixAlertDialog.Content>
    </RadixAlertDialog.Portal>
  </RadixAlertDialog.Root>
);
